import React from 'react'

const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-black text-white h-[150px] md:h-[100px] flex items-center justify-center">
        <p className="text-center text-[16px]">
        © 2024 Zuchy - w poszukiwaniu sensu życia. Wszelkie prawa zastrzeżone.
        </p>
    </footer>
  )
}

export default Footer